import React from 'react';
import { Card, Row, Col, Statistic, Button } from 'antd';
import { MessageOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const SmsDashboard = () => {
    const navigate = useNavigate();

    return (
        <div className="sms-dashboard">
            <Row gutter={16}>
                <Col span={12}>
                    <Card>
                        <Statistic
                            title="Gönderilen SMS"
                            value={1234}
                            prefix={<MessageOutlined />}
                        />
                    </Card>
                </Col>
                <Col span={12}>
                    <Card>
                        <Statistic
                            title="SMS Şablonları"
                            value={15}
                            prefix={<FileTextOutlined />}
                        />
                    </Card>
                </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: '20px' }}>
                <Col span={12}>
                    <Button
                        type="primary"
                        block
                        size="large"
                        onClick={() => navigate('/sms-bulk')}
                    >
                        Toplu SMS Gönder
                    </Button>
                </Col>
                <Col span={12}>
                    <Button
                        type="default"
                        block
                        size="large"
                        onClick={() => navigate('/sms-templates')}
                    >
                        SMS Şablonları
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default SmsDashboard; 